import { Payload, UseCase } from '@smile-next/uikit';
import { authParamsRepository, AuthParamsRepository } from '@/infra/repository/AuthParamsRepository';
import { AuthParams, AuthParamsConverter, AuthParamsJSON } from '@/models/domain/AuthParams';

export class LoadedAuthParamsPayload extends Payload {
    type = 'LoadedAuthParamsPayload';
    constructor(public readonly authParams: AuthParams) {
        super();
    }
}

type LoadAuthParamsUsecaseArgs = {
    authParamsRepository?: AuthParamsRepository;
};

export class LoadAuthParamsUseCase extends UseCase {
    private infra: Required<LoadAuthParamsUsecaseArgs>;
    constructor(args: LoadAuthParamsUsecaseArgs = {}) {
        super();
        this.infra = {
            authParamsRepository,
            ...args,
        };
    }

    execute(authParamsJSON: AuthParamsJSON) {
        const inputAuthParams = AuthParamsConverter.fromJSON(authParamsJSON);
        const savedAuthParams = this.infra.authParamsRepository.get();
        const authParams = savedAuthParams.join(inputAuthParams);

        this.dispatch(new LoadedAuthParamsPayload(authParams));
    }
}
